import React, { useContext } from "react";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import { AppContext } from "../App";
import { FaCheck, FaArrowRight } from "react-icons/fa";

const services = [
  {
    id: 1,
    title: "Audit & Assurance",
    description: "Professional audit services in accordance with ISA, focusing on internal controls and risk management.",
    image: banner4,
    features: [
      "External Audit",
      "Internal Audit",
      "Forensic and Fraud Investigation",
      "Risk Assurance",
      "Due Diligence",
    ],
    subItem: "internal-audit",
  },
  {
    id: 2,
    title: "Taxation",
    description: "Comprehensive tax planning and compliance to ensure business sustainability and regulatory adherence.",
    image: banner1,
    features: [
      "Tax Compliance and Advisory Services",
      "Tax Disputes Resolution",
      "Transfer Pricing",
      "International Taxation",
    ],
    subItem: "taxation",
  },
  {
    id: 3,
    title: "Accounting",
    description: "Accurate financial reporting and bookkeeping to support strategic decision-making processes.",
    image: banner2,
    features: [
      "Statutory Financial Statements",
      "Management Accounts",
      "Payroll Administration",
      "Accounting Transformation",
      "Book Keeping",
    ],
    subItem: "accounting",
  },
  {
    id: 4,
    title: "Advisory",
    description: "Expert business and financial advisory to help organizations achieve long-term growth objectives.",
    image: banner3,
    features: [
      "Financial & Business advisory",
      "Fund & Project Management",
      "HR Consulting",
      "Secretarial/Administrative",
      "Training",
    ],
    subItem: "advisory",
  },
];

const ServicesBanner1 = () => {
  const appContext = useContext(AppContext);

  return (
    <section className="atric-svc-section py-5">
      <div className="container">
        {/* HEADER */}
        <div className="atric-svc-header text-center mb-5">
          <h2 className="atric-svc-title">Our Services</h2>
          <div className="atric-title-line mx-auto"></div>
          <p className="atric-svc-subtitle mt-3">
            Delivering quality and timely professional services for clients to 
            manage and grow their businesses in Tanzania and East Africa.
          </p>
        </div>

        {/* GRID */}
        <div className="row g-4">
          {services.map((service) => (
            <div key={service.id} className="col-lg-6">
              <div
                className="atric-svc-card"
                onClick={() =>
                  appContext.navTo({
                    item: "services",
                    subItem: service.subItem,
                  })
                }
              >
                <div className="row g-0 h-100">
                  {/* IMAGE - Desktop side, Mobile top */}
                  <div className="col-sm-5 atric-svc-card__img-container">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="atric-svc-card__img"
                    />
                  </div>

                  {/* CONTENT */}
                  <div className="col-sm-7">
                    <div className="atric-svc-card__body p-4 d-flex flex-column h-100">
                      <h3 className="atric-svc-card__heading">{service.title}</h3>
                      <p className="atric-svc-card__text">{service.description}</p>

                      <ul className="atric-svc-card__list">
                        {service.features.map((f, i) => (
                          <li key={i} className="d-flex align-items-start gap-2">
                            <FaCheck size={10} className="text-accent mt-1" />
                            <span>{f}</span>
                          </li>
                        ))}
                      </ul>

                      <div className="atric-svc-card__footer mt-auto">
                        <span className="atric-link">
                          View Details <FaArrowRight size={12} className="ms-1" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA SECTION */}
        <div className="atric-cta-box text-center mt-5 p-5 shadow-lg rounded-4">
          <h4 className="fw-bold text-white mb-3">Looking for a Reliable Audit Partner?</h4>
          <p className="text-white-50 mb-4 mx-auto" style={{ maxWidth: '600px' }}>
            Work with a committed team of CPAs focused on transparency, 
            timeliness, and adding value to your organization.
          </p>
          <button
            className="atric-btn-white"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            Contact ATRIC Today
          </button>
        </div>
      </div>

      <style jsx>{`
        .atric-svc-section {
          background-color: #f8fafc;
          font-family: 'Inter', sans-serif;
        }

        .atric-svc-title {
          font-weight: 800;
          color: #1e3fae;
          font-size: 2.5rem;
        }

        .atric-title-line {
          width: 60px;
          height: 4px;
          background: #0284c7;
          border-radius: 2px;
        }

        .atric-svc-subtitle {
          color: #64748b;
          font-size: 1.1rem;
          max-width: 650px;
          margin: 0 auto;
        }

        .atric-svc-card {
          background: #ffffff;
          border-radius: 16px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.4s ease;
          border: 1px solid rgba(0,0,0,0.05);
          height: 100%;
        }

        .atric-svc-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 30px rgba(15, 23, 42, 0.08);
          border-color: #0284c7;
        }

        .atric-svc-card__img-container {
          overflow: hidden;
          min-height: 200px;
        }

        .atric-svc-card__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .atric-svc-card:hover .atric-svc-card__img {
          transform: scale(1.1);
        }

        .atric-svc-card__heading {
          font-size: 1.25rem;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 0.8rem;
        }

        .atric-svc-card__text {
          font-size: 0.9rem;
          color: #64748b;
          line-height: 1.5;
          margin-bottom: 1rem;
        }

        .atric-svc-card__list {
          padding: 0;
          list-style: none;
          margin-bottom: 1.5rem;
        }

        .atric-svc-card__list li {
          font-size: 0.85rem;
          color: #334155;
          margin-bottom: 0.5rem;
          font-weight: 500;
          line-height: 1.2;
        }

        .text-accent { color: #0284c7; }

        .atric-link {
          color: #0284c7;
          font-weight: 700;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .atric-cta-box {
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        }

        .atric-btn-white {
          background: #ffffff;
          color: #0f172a;
          border: none;
          padding: 14px 40px;
          border-radius: 8px;
          font-weight: 700;
          transition: 0.3s;
        }

        .atric-btn-white:hover {
          background: #0284c7;
          color: #ffffff;
          transform: translateY(-3px);
        }

        @media (max-width: 576px) {
          .atric-svc-card__img-container { height: 200px; }
        }
      `}</style>
    </section>
  );
};

export default ServicesBanner1;